<template>
    <div class="grid-row d-flex d-flex-row w-100">
        <slot></slot>
    </div>
</template>

<style lang="sass" scoped>
    $grey-color: #efefef
    $border-color: darken($grey-color, 7%)

    .grid-row
        border: 1px solid $border-color
        border-radius: 4px
        margin-top: 15px

</style>

<script>
    export default {};
</script>
